import React from "react";
import {
  EditablePreview,
  IconButton,
  Input,
  useEditableControls,
  ButtonGroup,
  Editable,
  Tooltip,
  EditableInput,
} from "@chakra-ui/react";
import { CheckIcon, CloseIcon } from "@chakra-ui/icons";

export const EditableInputComponent = ({ title, update }) => {
  function EditableControls() {
    const { isEditing, getSubmitButtonProps, getCancelButtonProps } =
      useEditableControls();

    return isEditing ? (
      <ButtonGroup justifyContent="end" ml={1} size="xs">
        <IconButton
          icon={<CheckIcon />}
          {...getSubmitButtonProps()}
          colorScheme="blue"
        />
        <IconButton
          icon={<CloseIcon boxSize={3} />}
          {...getCancelButtonProps()}
          colorScheme="blue"
        />
      </ButtonGroup>
    ) : null;
  }

  return (
    <Editable
      defaultValue={title}
      isPreviewFocusable={true}
      selectAllOnFocus={false}
      className="title"
      onSubmit={update}
      padding={0}
    >
      <Tooltip label="Click to edit" shouldWrapChildren={true}>
        <EditablePreview />
      </Tooltip>
      <Input as={EditableInput} />
      <EditableControls />
    </Editable>
  );
};
